export const calculateTokenValue = (
  tokenAmount?: bigint | null,
  priceValue?: bigint | null,
  tokenDecimals?: number | null,
) => {
  if (tokenAmount == null || priceValue == null || tokenDecimals == null)
    return undefined

  const divider = 10n ** BigInt(tokenDecimals)
  if (divider === 0n) return undefined

  return (tokenAmount * priceValue) / divider
}
